import { useState } from "react";
import { useLocation } from "wouter";
import { AuthShell, Field, SubmitButton } from "./AuthShell";
import { useCaptcha } from "./useCaptcha";
import { t } from "../../locale";
import { useAuth } from "../../stores/auth";

export const ForgotPassword = () => {
  const [, navigate] = useLocation();
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const captcha = useCaptcha(setError);
  const resetPassword = useAuth((s) => s.resetPassword);

  const ready =
    email.trim().length > 0 && (captcha.token !== null || captcha.bypassed);

  const submit = async () => {
    setBusy(true);
    setError(null);
    await resetPassword(email.trim(), captcha.token ?? undefined);
    setBusy(false);

    const authError = useAuth.getState().error;
    if (authError) {
      setError(authError);
      captcha.reset();
      return;
    }
    // Deliberately identical whether or not the address has an account, so
    // this screen cannot be used to test which addresses are registered.
    setSent(true);
  };

  return (
    <AuthShell title={t.auth.forgotPassword} error={error}>
      {sent ? (
        <>
          <p className="text-sm text-ink-dim">{t.auth.resetSent}</p>
          <SubmitButton
            label={t.auth.signIn}
            disabled={false}
            onClick={() => navigate("/auth/sign-in")}
          />
        </>
      ) : (
        <>
          <Field
            label={t.auth.email}
            type="email"
            value={email}
            onChange={setEmail}
            autoComplete="email"
          />
          {captcha.widget}
          <SubmitButton
            label={t.auth.sendResetLink}
            disabled={!ready || busy}
            onClick={submit}
          />
        </>
      )}
    </AuthShell>
  );
};
